import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import Root from './containers/Root';
import configureStore from './store/configureStore';
import {redirectCustomerData, redirectToLogin} from './actions/auth';

const store = configureStore(window.__INITIAL_STATE__);

const history = syncHistoryWithStore(browserHistory, store);

let token = localStorage.getItem('token');
if ('token' in localStorage) {
	store.dispatch(redirectCustomerData(token));
}else{
	store.dispatch(redirectToLogin());
}

ReactDOM.render(<Root store={store} history={history} />, document.getElementById('root'));


/** WEBPACK FOOTER **
 ** ./js/index.js
 **/